module.exports = __webpack_public_path__ + "static/media/Kuva_3_3.a6c0e1e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Kuva_3_3.png
// module id = 1398
// module chunks = 0